import { cloneArr, currentTimeMillis, generateHex, Module } from '@nu-art/ts-common';
import { StorageKey } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_AdvisorSession } from '../../_entity/advisor-session/index.js';
import { dispatch_onRequestHistoryChanged } from '../../ui/sandbox/Page_BaseSandbox/Base_RequestHistory/index.js';
export class ModuleFE_MessagesTracker extends Module {
    constructor() {
        super();
    }
    addMessageToHistory(historyItem) {
        const messageHistory = cloneArr(this.getHistory());
        messageHistory.push({ ...historyItem, timestamp: currentTimeMillis(), uid: generateHex(8) });
        this.setHistory(messageHistory);
        dispatch_onRequestHistoryChanged.dispatchUI();
    }
    addErrorMessageToHistory(error) {
        this.addMessageToHistory({ type: 'error', content: error });
    }
    getHistory() {
        return this.getStorageKey().get([]);
    }
    clearHistory() {
        this.getStorageKey().delete();
    }
    getStorageKey() {
        return new StorageKey(`messages-history--${ModuleFE_AdvisorSession.getCurrentEncounterId()}`);
    }
    setHistory(history) {
        this.getStorageKey().set(history);
    }
}
//# sourceMappingURL=ModuleFE_MessagesTracker.js.map